document.addEventListener("DOMContentLoaded", function () {
  var dispatchCustomEvent = function dispatchCustomEvent(eventName) {
    var data =
      arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
    var detail = {
      detail: data,
    };
    var event = new CustomEvent(eventName, data ? detail : null);
    document.dispatchEvent(event);
  };

  // Hide Search Bar on scroll
  /* SE - 18 Feb '26 */
  /*
  let searchBar = document.getElementsByClassName("header__mobile-search")[0];
  window.addEventListener("scroll", function () {
    let scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    if (scrollTop === 0) {
      searchBar.style.display = "block";
    } else {
      searchBar.style.display = "none";
    }
  });*/

  const productionSpeedRadioButtons = document.querySelectorAll(
    'input[name="productionSpeed"]'
  );
  const proofBeforeShippingRadioButtons = document.querySelectorAll(
    'input[name="proofBeforeShipping"]'
  );
  const artworkRedesignRadioButtons = document.querySelectorAll(
    'input[name="custom-artwork-design"]'
  );
  const backSideRadioButtons = document.querySelectorAll(
    'input[name="backSide"]'
  );
  const dressItemsRadioButtons = document.querySelectorAll(
    'input[name="dressItems"]'
  );
  const customPrintRadioButtons = document.querySelectorAll(
    'input[name="customPrint"]'
  );

  productionSpeedRadioButtons.forEach((radio) => {
    radio.addEventListener("change", () => {
      productionSpeedRadioButtons.forEach((rb) => (rb.checked = false));
      radio.checked = true;
    });
  });

  proofBeforeShippingRadioButtons.forEach((radio) => {
    radio.addEventListener("change", () => {
      proofBeforeShippingRadioButtons.forEach((rb) => (rb.checked = false));
      radio.checked = true;
    });
  });

  artworkRedesignRadioButtons.forEach((radio) => {
    radio.addEventListener("change", () => {
      artworkRedesignRadioButtons.forEach((rb) => (rb.checked = false));
      radio.checked = true;
    });
  });

  backSideRadioButtons.forEach((radio) => {
    radio.addEventListener("change", () => {
      backSideRadioButtons.forEach((rb) => (rb.checked = false));
      radio.checked = true;
    });
  });

  dressItemsRadioButtons.forEach((radio) => {
    radio.addEventListener("change", () => {
      dressItemsRadioButtons.forEach((rb) => (rb.checked = false));
      radio.checked = true;
    });
  });

  customPrintRadioButtons.forEach((radio) => {
    radio.addEventListener("change", () => {
      customPrintRadioButtons.forEach((rb) => (rb.checked = false));
      radio.checked = true;
    });
  });

  document.querySelectorAll(".AddToCartBtn").forEach((item) => {
    item.addEventListener("click", function (e) {
      e.preventDefault();
      let id = document.getElementById("variant_id").value;
      let quantity = 1;
      if (document.querySelector(".quantity_selector") != null) {
        quantity = +document.querySelector(".quantity_selector").value;
      }

      const customPrintedContainer = document.querySelector(
        ".custom-printed__container"
      );

      if (customPrintedContainer) {
        handleCustomPrintedAddToCart(id, quantity);
      } else {
        handleRegularAddToCart(id, quantity);
      }
    });
  });

  function handleCustomPrintedAddToCart(id, quantity) {
    let downcase_title = document
      .querySelector(".main__product-content")
      .getAttribute("data-title")
      .toLowerCase();
    let isBandanna = downcase_title.includes("bandanna");
    let isButton = downcase_title.includes("button");

    // for Bundle Products
    let productTypeElement = document.getElementById("mainProduct"),
      productType = productTypeElement
        ? productTypeElement.getAttribute("data-type")
        : null;
    if (productType && document.querySelector(".quantity_selector") != null) {
      quantity = +document.querySelector(".quantity_selector").value / 12;
    }

    // clear error messages
    const errorMessages = document.querySelectorAll(".error-highlight");
    errorMessages.forEach((element) => {
      element.classList.remove("error-highlight");
    });

    let minQuantity = document.querySelector(".quantity_selector")
      ? document.querySelector(".quantity_selector").getAttribute("data-min")
      : null;

    // check val of quantity
    if (quantity === "" || isNaN(Number(quantity))) {
      errorMessage("Please enter a valid quantity.");
      return;
    }

    if (minQuantity) {
      if (quantity < minQuantity) {
        errorMessage(
          `oops you've put in the wrong number – this can only be ordered in multiples of ${minQuantity}`
        );
        return;
      }
    }

    let product_id = document
      .querySelector(".main__product-customfields")
      .getAttribute("product-id");

    if (product_id != 1651960774758) {
      handleCustomPrintedProducts(
        id,
        quantity,
        isBandanna,
        isButton,
        product_id
      );
    } else if (product_id == 1651960774758) {
      handleSpecificProduct(id, quantity, product_id);
    } else {
      console.log("Unhandled case for custom printed container");
      errorMessage("Unable to process this product type.");
    }
  }

  function handleRegularAddToCart(id, quantity) {
    addToCart(id, quantity);
  }

  function handleCustomPrintedProducts(
    id,
    quantity,
    isBandanna,
    isButton,
    product_id
  ) {
    if (isButton) {
      buttonColor = document.getElementById("button_colors").value;
      if (buttonColor == "default") {
        errorMessage("Missing field: Choose button color.", [
          document.getElementById("button_colors"),
        ]);
        return;
      }

      id = document.getElementById("button_colors").value;
      console.log(id, "id");
    }

    let soldSeperately = document.querySelector('input[name="soldSeparately"]');
    if (!soldSeperately.checked) {
      errorMessage(
        "Missing field: I understand that the stuffed animals are sold separately",
        [soldSeperately.parentElement]
      );
      return;
    }
    soldSeperately = soldSeperately.value;

    let notExternalPlush = document.querySelector(
      'input[name="customPrint"]:checked'
    );
    let whatItems = false;
    let shirtSize = false;
    let dressItems = false;
    if (!isButton) {
      if (!notExternalPlush) {
        const validationOptions = document.querySelectorAll(
          "label.custom_print__option"
        );
        errorMessage(
          "Missing field: Will the custom-printed items go on plush you buy from us?",
          validationOptions
        );
        return;
      }
      notExternalPlush = notExternalPlush.value;

      if (notExternalPlush == "yes") {
        if (!document.getElementById("shirtSize__yes").value) {
          errorMessage("Missing field: Which items will wear the t-shirts?", [
            document.getElementById("shirtSize__yes"),
          ]);
          return;
        }
        whatItems = document.getElementById("shirtSize__yes").value;
      } else {
        if (!document.getElementById("shirtSize__no").value) {
          errorMessage("Missing field: Choose Shirt Size", [
            document.getElementById("shirtSize__no"),
          ]);
          return;
        }
        shirtSize = document.getElementById("shirtSize__no").value;
      }

      let dressItemsElement = document.querySelector(
        "input[name='dressItems']:checked"
      );
      if (!dressItemsElement) {
        let validationOptions = document.querySelectorAll(
          "label.dress_items__option"
        );
        errorMessage(
          "Missing field: Do you want us to dress the items for you?",
          validationOptions
        );
        return;
      }
      dressItems = dressItemsElement.value;
    }

    let frontImage = document.getElementById("file-input-test").value;
    let printOnOtherSide, backImage;

    if (!isBandanna && !isButton) {
      printOnOtherSide = document.querySelector(
        'input[name="backSide"]:checked'
      );
      if (!printOnOtherSide) {
        let validationOptions = document.querySelectorAll(
          "label.back_side__option"
        );
        errorMessage(
          "Missing field: Do you want the other side printed too?",
          validationOptions
        );
        return;
      }
      printOnOtherSide = printOnOtherSide.value;
      backImage = document.getElementById("file-input__back_side_test").value;
    }

    let artworkRedesign = document.querySelector(
      'input[name="custom-artwork-design"]:checked'
    );
    if (!artworkRedesign) {
      let validationOptions = document.querySelectorAll(
        '[data-validation-field="custom-artwork-design__option"]'
      );
      errorMessage(
        "Missing field: Do you want your artwork redesigned?",
        validationOptions
      );
      return;
    }
    artworkRedesign = artworkRedesign.value;

    let artworkRedesignComments = document.getElementById(
      "custom_artwork_design__notes"
    ).value;
    if (artworkRedesign == "yes" && !artworkRedesignComments) {
      errorMessage("Missing field: Custom artwork redesign notes.", [
        document.getElementById("custom_artwork_design__notes"),
      ]);
      return;
    }

    let productionSpeed = document.querySelector(
      'input[name="productionSpeed"]:checked'
    );
    if (!productionSpeed) {
      let validationOptions = document.querySelectorAll(
        '[data-validation-field="productionSpeed__option"]'
      );
      errorMessage("Missing field: Production speed.", validationOptions);
      return;
    }
    productionSpeed = productionSpeed.value;

    let proofBeforeShipping = document.querySelector(
      'input[name="proofBeforeShipping"]:checked'
    );
    if (!proofBeforeShipping) {
      const validationOptions = document.querySelectorAll(
        '[data-validation-field="proofBeforeShipping__option"]'
      );
      errorMessage(
        "Missing field: Do you want proof before shipping?",
        validationOptions
      );
      return;
    }
    proofBeforeShipping = proofBeforeShipping.value;

    let properties = {
      "I understand that the stuffed animals are sold separately":
        soldSeperately,
    };

    if (!isButton) {
      if (notExternalPlush !== "")
        properties[
          "Will the custom-printed items go on plush you buy from us?"
        ] = notExternalPlush;
    }
    if (whatItems !== false)
      properties["Which items will wear the t-shirts?"] = whatItems;
    if (shirtSize !== false) properties["Choose Shirt Size"] = shirtSize;
    if (!isButton) {
      if (dressItems !== "")
        properties["Do you want us to dress the items for you?"] = dressItems;
    }
    if (frontImage !== "") properties["Upload your Art"] = frontImage;
    if (!isBandanna) {
      if (printOnOtherSide !== "")
        properties["Do you want the other side printed too?"] =
          printOnOtherSide;
      if (backImage !== "") properties["Upload File (Back Side)"] = backImage;
    }
    if (artworkRedesign !== "")
      properties["Do you want your artwork redesigned? (includes proof)"] =
        artworkRedesign;
    if (artworkRedesignComments !== "")
      properties[
        "Describe the changes you want in detail (ex: type of font, color of text, words to say, colors changed, background removed)"
      ] = artworkRedesignComments;
    if (productionSpeed !== "")
      properties["Production Speed"] = productionSpeed;
    if (proofBeforeShipping !== "")
      properties["Do you want proof before shipping?"] = proofBeforeShipping;

    let additionalItems = [];

    if (!isButton && dressItems == "yes") {
      additionalItems.push({
        id: "45174369091885", // Variant ID for dressItems
        quantity: quantity,
      });
    }

    if (!isBandanna && !isButton && printOnOtherSide == "yes") {
      additionalItems.push({
        id: "45174965961005", // Variant ID for printOnOtherSide
        quantity: quantity,
      });
    }

    if (artworkRedesign == "yes") {
      additionalItems.push({
        id: "45361501536557", // Variant ID for artworkRedesign
        quantity: 1,
      });
    }

    if (productionSpeed == "expedited") {
      additionalItems.push({
        id: "45174454157613", // Variant ID for productionSpeed
        quantity: quantity,
      });
    }

    if (proofBeforeShipping == "yes") {
      additionalItems.push({
        id: "45175001645357", // Variant ID for proofBeforeShipping
        quantity: 1,
      });
    }

    addToCart(id, quantity, properties, additionalItems);
  }

  let ribbon_color;
  let your_message;
  let ink_colors;
  let font_name;
  let soldSeperately;
  let symbol;
  let buttonColor;

  function handleSpecificProduct(id, quantity, product_id) {
    soldSeperately = document.querySelector('input[name="soldSeparately"]');
    if (!soldSeperately.checked) {
      errorMessage(
        "Missing field: I understand that the stuffed animals are sold separately.",
        [soldSeperately.parentElement]
      );
      return;
    }
    soldSeperately = soldSeperately.value;
    if (product_id == 1651960774758) {
      ink_colors = document.getElementById("ink_colors").value;
      if (ink_colors == "default") {
        errorMessage("Missing field: Choose ink color.", [
          document.getElementById("ink_colors"),
        ]);
        return;
      }

      ribbon_color = document.getElementById("ribbon_colors").value;
      if (ribbon_color == "default") {
        errorMessage("Missing field: Choose ribbon color.", [
          document.getElementById("ribbon_colors"),
        ]);
        return;
      }

      your_message = document.getElementById("your_message").value;
      if (your_message == "") {
        errorMessage("Missing field: Your message.", [
          document.querySelector('[data-validation-field="your_message"]'),
        ]);
        return;
      }

      font_name = document.getElementById("font_name").value;
      if (font_name == "default") {
        errorMessage("Missing field: Choose font.", [
          document.getElementById("font_name"),
        ]);
        return;
      }

      symbol = document.getElementById("symbol").value;
      if (symbol == "default") {
        errorMessage(
          "Missing field: Choose symbol to appear between the messages.",
          [document.getElementById("symbol")]
        );
        return;
      }
    }

    let productionSpeed = document.querySelector(
      'input[name="productionSpeed"]:checked'
    );
    if (!productionSpeed) {
      let validationOptions = document.querySelectorAll(
        '[data-validation-field="productionSpeed__option"]'
      );
      errorMessage("Missing field: Production speed.", validationOptions);
      return;
    }

    productionSpeed = productionSpeed.value;

    let properties = {
      "I understand that the stuffed animals are sold separately":
        soldSeperately,
      "Ink color": ink_colors,
      "Ribbon color": ribbon_color,
      "Button color": buttonColor,
      "Your message": your_message,
      Font: font_name,
      Symbol: symbol,
      "Production Speed": productionSpeed,
    };

    let additionalItems = [];

    if (productionSpeed == "expedited") {
      additionalItems.push({
        id: "46958021574957", // Variant ID for productionSpeed
        quantity: quantity,
      });
    }

    addToCart(id, quantity, properties, additionalItems);
  }

  function addToCart(id, quantity, properties = {}, additionalItems = []) {
    let itemsToAdd = [
      {
        id: id,
        quantity: quantity,
        properties: properties,
      },
      ...additionalItems,
    ];

    fetch("/cart/add.js", {
      method: "post",
      headers: {
        "Content-Type": "application/json;charset=utf-8",
      },
      body: JSON.stringify({ items: itemsToAdd }),
    })
      .then((response) => response.json())
      .then((result) => {
        document.querySelectorAll("#cart-drawer-toggle")[0].click();
        console.log("success", result);
        const event = new Event("cart:refresh");
        document.addEventListener("cart:refresh", (e) => {}, false);
        document.dispatchEvent(event);
      })
      .catch((error) => {
        console.error("Error:", error);
        errorMessage("Failed to add item to cart. Please try again.");
      });
  }

  function errorMessage(errMessage, elements = null) {
    const formError = document.getElementById("form-error");
    const defaultMessage = "Please make sure all fields are filled out.";
    formError.textContent = errMessage || defaultMessage;

    if (elements) {
      elements.forEach((element) => {
        element.classList.add("error-highlight");
      });
    }

    formError.scrollIntoView();

    setTimeout(() => {
      formError.textContent = "";
    }, 5000);
  }

  // Bundle Add to Cart
  document.querySelectorAll(".BundleAddToCartBtn").forEach((item) => {
    item.addEventListener("click", function (e) {
      e.preventDefault();
      let id = document.getElementById("bundleId").value;

      let quantity = 1;
      if (document.querySelector(".quantity_selector") != null) {
        quantity = +document.querySelector(".quantity_selector").value;
      }
      // for Bundle Products
      let productTypeElement = document.getElementById("mainProduct"),
        productType = productTypeElement.getAttribute("data-type"),
        bundleSelect = document.getElementById("bundleId"),
        selectedOption = bundleSelect.options[bundleSelect.selectedIndex],
        dataTitle = selectedOption.getAttribute("data-title");

      if (
        productType &&
        document.querySelector(".quantity_selector") != null &&
        dataTitle === "Assorted"
      ) {
        quantity = +document.querySelector(".quantity_selector").value / 12;
      }
      fetch("/cart/add.js", {
        method: "post",
        headers: {
          "Content-Type": "application/json;charset=utf-8",
        },
        body: JSON.stringify({
          id,
          quantity,
        }),
      })
        .then((response) => response.json())
        .then((result) => {
          document.querySelectorAll("#cart-drawer-toggle")[0].click();
          console.log("success", result);
          const event = new Event("cart:refresh");

          document.addEventListener("cart:refresh", (e) => {}, false);
          document.dispatchEvent(event);
        });
    });
  });

  // The rest of your existing code (Blog Filters, product variant handling, etc.) goes here
  // ...
  //     // Blog Filters
  const filterItems = document.querySelectorAll(".articles__filters-item");
  const blogItems = document.querySelectorAll(".blog-item");

  function filterBlogItems(tag) {
    blogItems.forEach((blogItem) => {
      if (blogItem.getAttribute("data-tag") === tag) {
        blogItem.style.display = "block";
      } else {
        blogItem.style.display = "none";
      }
    });
  }

  filterItems.forEach((item) => {
    item.addEventListener("click", function () {
      filterItems.forEach((i) => i.classList.remove("active"));
      this.classList.add("active");
      const selectedTag = this.textContent.trim();
      filterBlogItems(selectedTag);
    });
  });

  // get an array with options of clicked variant (ie value: 'Black', index: 'option1')
  function getVariantFromSwatches() {
    let variantArr = [];
    document
      .querySelectorAll(".product-option input[type=radio]")
      .forEach((el) => {
        if (el.checked) {
          variantArr.push({
            value: el.value,
            index: el.getAttribute("data-index"),
          });
        }
      });

    // Get variants from dropdown selectors
    document.querySelectorAll(".product-option select").forEach((el) => {
      let selectedOption = el.options[el.selectedIndex];
      variantArr.push({
        value: selectedOption.value,
        index: el.getAttribute("data-index"),
      });
    });

    return variantArr;
  }

  // update URL
  function updateHistoryState(variant) {
    if (!history.replaceState || !variant) {
      return;
    }
    let newUrl =
      window.location.protocol +
      "//" +
      window.location.host +
      window.location.pathname +
      "?variant=" +
      variant.id;

    window.history.replaceState({ path: newUrl }, "", newUrl);
  }

  // Money Format
  theme.Currency = (function () {
    let moneyFormat = "${{amount}}";
    function formatMoney(cents, format) {
      if (typeof cents === "string") {
        cents = cents.replace(".", "");
      }
      let value = "";
      let placeholderRegex = /\{\{\s*(\w+)\s*\}\}/;
      let formatString = format || moneyFormat;

      function formatWithDelimiters(number, precision, thousands, decimal) {
        thousands = thousands || ",";
        decimal = decimal || ".";

        if (isNaN(number) || number === null) {
          return 0;
        }

        number = (number / 100.0).toFixed(precision);

        let parts = number.split(".");
        let dollarsAmount = parts[0].replace(
          /(\d)(?=(\d\d\d)+(?!\d))/g,
          "$1" + thousands
        );
        let centsAmount = parts[1] ? decimal + parts[1] : "";

        return dollarsAmount + centsAmount;
      }

      switch (formatString.match(placeholderRegex)[1]) {
        case "amount":
          value = formatWithDelimiters(cents, 2);
          break;
        case "amount_no_decimals":
          value = formatWithDelimiters(cents, 0);
          break;
        case "amount_with_comma_separator":
          value = formatWithDelimiters(cents, 2, ".", ",");
          break;
        case "amount_no_decimals_with_comma_separator":
          value = formatWithDelimiters(cents, 0, ".", ",");
          break;
        case "amount_no_decimals_with_space_separator":
          value = formatWithDelimiters(cents, 0, " ");
          break;
        case "amount_with_apostrophe_separator":
          value = formatWithDelimiters(cents, 2, "'");
          break;
      }

      return formatString.replace(placeholderRegex, value);
    }
    return {
      formatMoney: formatMoney,
    };
  })();

  //change class for swatch
  document.querySelectorAll(".swatch").forEach(function (swatch) {
    swatch.addEventListener("click", function () {
      const optionsWrap = swatch.closest(".options_wrap");
      optionsWrap.querySelectorAll(".swatch").forEach(function (s) {
        s.classList.remove("active");
      });
      swatch.classList.add("active");
    });
  });

  function update_variant_id(variant) {
    document.getElementById("variant_id").value = variant;
  }

  // Main slider
  let galleryTop = new Swiper(".gallery-top", {
    spaceBetween: 10,
    slidesPerView: 1,
    navigation: {
      nextEl: ".swiper-gallery-next",
      prevEl: ".swiper-gallery-prev",
    },
  });

  var galleryThumbs = new Swiper(".gallery-thumbs", {
    spaceBetween: 16,
    slidesPerView: "auto",
    centeredSlides: false,
    touchRatio: 0.2,
    slideToClickedSlide: true,
    breakpoints: {
      990: {
        spaceBetween: 12
      },
    },
  });

  galleryTop.controller.control = galleryThumbs;
  galleryThumbs.controller.control = galleryTop;

  function update_slider_image(variantImg, customDataIndex = false) {
    if(customDataIndex) {
      galleryTop.slideTo(customDataIndex - 1);
    } else {
      const slides = document.querySelectorAll(".gallery-top .swiper-slide");
  
      slides.forEach((slide) => {
        if (+slide.getAttribute("data-id") === variantImg) {
          const dataIndex = slide.getAttribute("data-index");
          galleryTop.slideTo(dataIndex - 1);
        }
      });
    }
  }

  galleryThumbs.on('click', function (swiper, event) {
    const clickedIndex = swiper.clickedIndex;
    if (clickedIndex !== undefined) {
      galleryTop.slideTo(clickedIndex);
    }

    document.querySelectorAll('.gallery-thumbs .swiper-slide_thumb').forEach(slide => {
      slide.classList.remove('swiper-slide-active');
      slide.classList.remove('swiper-slide-prev');
      slide.classList.remove('swiper-slide-next');
    });
  
    const thumbsSlides = document.querySelectorAll('.gallery-thumbs .swiper-slide_thumb');
    if (thumbsSlides[clickedIndex]) {
      thumbsSlides[clickedIndex].classList.add('swiper-slide-active');
      if(thumbsSlides[clickedIndex - 1]) {
        thumbsSlides[clickedIndex - 1].classList.add('swiper-slide-prev');
      }
      if(thumbsSlides[clickedIndex + 1]) {
        thumbsSlides[clickedIndex + 1].classList.add('swiper-slide-next');
      }
    }
  });

  galleryTop.on('slideChange', function () {
    const activeIndex = galleryTop.activeIndex;
    /*SE- 12 May '25*/
    //galleryThumbs.slideTo(activeIndex);
    
    document.querySelectorAll('.gallery-thumbs .swiper-slide_thumb').forEach(slide => {
      slide.classList.remove('swiper-slide-active');
      slide.classList.remove('swiper-slide-prev');
      slide.classList.remove('swiper-slide-next');
    });
  
    const thumbsSlides = document.querySelectorAll('.gallery-thumbs .swiper-slide_thumb');
    if (thumbsSlides[activeIndex]) {
      thumbsSlides[activeIndex].classList.add('swiper-slide-active');
      if(thumbsSlides[activeIndex - 1]) {
        thumbsSlides[activeIndex - 1].classList.add('swiper-slide-prev');
      }
      if(thumbsSlides[activeIndex + 1]) {
        thumbsSlides[activeIndex + 1].classList.add('swiper-slide-next');
      }
    }
  });


  let is_Potm = false;
  is_Potm = document.querySelector('[is-potm="true"]');
  if (is_Potm) {
    let price_span = document.getElementById("regular_price");
    let potmObject = window.potoObject[0];
    let originalPrice = parseFloat(
      price_span.textContent.replace("$", "").replace(" per piece", "")
    );
    document
      .querySelectorAll(".main__product-form .plus, .main__product-form .minus")
      .forEach((item) => {
        item.addEventListener("click", () => {
          setTimeout(() => {
            let quantity = parseInt(
              document.querySelector(".quantity_selector").value
            );
            let discountedPrice = originalPrice;

            // Find the applicable discount tier=
            for (let i = 0; i < potmObject.discount_minimum.length; i++) {
              if (quantity >= potmObject.discount_minimum[i]) {
                // Apply percentage discount
                let discountPercentage = parseFloat(
                  potmObject.discount_amount[i]
                );
                discountedPrice =
                  originalPrice * (1 - discountPercentage / 100);
              } else {
                break; // Stop if we've passed the applicable tier
              }
            }

            // Update the price span with the new price
            price_span.textContent =
              window.currencySymbol + discountedPrice.toFixed(2) + " per piece";
          }, 200);
        });
      });
  }

  function update_product_price(variant) {


    /*SHOPEXPERTS - 15 FEB '25*/
    document.querySelector("#variant-value-unique")?.setAttribute("data-variant-id", variant.id);
    const seVariantIdMetafieldValueBackEnd = variantsData[variant.id].trim();
    const seVariantIdOutOfStockMetafieldValueBackEnd = variantsDataOutOfStock[variant.id].trim();
    
    let seVariantMetafieldValue = " per piece";
    let seVariantOutOfStockMetafieldValue = " Due Date: TBD";

    const seQuantityTitle = document.querySelector(".main-product__text-block__quantity__title");
    const seQuantitySelector = document.querySelector(".se-quantity-selector-product");
    const seQuantityTextBelow = document.querySelector(".must-purchased-text");

    if(!variant.available) {
      if(!seQuantityTitle.classList.contains("se-hidden")) {
        seQuantityTitle?.classList.add("se-hidden");
        seQuantitySelector?.classList.add("se-hidden");
        seQuantityTextBelow?.classList.add("se-hidden");
      }
    } else {
      if(seQuantityTitle.classList.contains("se-hidden")) {
        seQuantityTitle?.classList.remove("se-hidden");
        seQuantitySelector?.classList.remove("se-hidden");
        seQuantityTextBelow?.classList.remove("se-hidden");
      }
    }

    if(seVariantIdMetafieldValueBackEnd && seVariantIdMetafieldValueBackEnd.trim().length) {
      seVariantMetafieldValue = ` ${seVariantIdMetafieldValueBackEnd}`;
    }

    const outOfStockText = document.querySelector("#se-out-of-stock_text");
    if(!variant.available) {
      if(seVariantIdOutOfStockMetafieldValueBackEnd && seVariantIdOutOfStockMetafieldValueBackEnd.trim().length) {
        seVariantOutOfStockMetafieldValue = ` ${seVariantIdOutOfStockMetafieldValueBackEnd}`;
      }
      if(outOfStockText.classList.contains("se-hidden")) {
        outOfStockText.classList.remove("se-hidden");
      }
    } else {
      if(!outOfStockText.classList.contains("se-hidden")) {
        outOfStockText.classList.add("se-hidden");
      }
    }

    outOfStockText.textContent = seVariantOutOfStockMetafieldValue;


    /*SHOPEXPERTS - Badges*/
    const seProductLabelRepeated = document.querySelector(".product-label-wrap-repeated");
    seProductLabelRepeated?.remove();
    
    const seInventoryQuantity = variant.inventory;
    const seProductLabel = document.querySelector(".product-label-wrap:not(.product-label-wrap-repeated)");

    if(seInventoryQuantity <= 0) {
      if(seProductLabel) {
        seProductLabel.style.display = "flex";
        seProductLabel.className = "";
        seProductLabel.classList.add("product-label-wrap", "sold-out-wrap");
        seProductLabel.querySelector("p").textContent = "Sold out!";
      }
    }

    if(seInventoryQuantity > 0 && seInventoryQuantity < 24) {
      if(seProductLabel) {
        seProductLabel.style.display = "flex";
        seProductLabel.className = "";
        seProductLabel.classList.add("product-label-wrap", "low-in-stock-wrap");
        seProductLabel.querySelector("p").innerHTML = `Only <b>${seInventoryQuantity}</b><br/>Left`;
      }
    }

    if(seInventoryQuantity >= 24) {
      if(seProductLabel) {
        seProductLabel.style.display = "none";
      }
    }

    if(variant.compare_at_price && variant.price < variant.compare_at_price) {
      if(seProductLabel) {
        seProductLabel.style.display = "flex";
        seProductLabel.className = "";
        seProductLabel.classList.add("product-label-wrap", "sale");
        seProductLabel.querySelector("p").textContent = "Sale";
      }
    }

    if(variant.compare_at_price && variant.price < variant.compare_at_price && seInventoryQuantity <= 0) {
      if(seProductLabel) {
        seProductLabel.style.display = "flex";
        seProductLabel.className = "";
        seProductLabel.classList.add("product-label-wrap", "sale");
        seProductLabel.querySelector("p").textContent = "Sale";

        const seDiv = document.createElement("div");
        seDiv.classList.add("product-label-wrap", "sold-out-wrap", "product-label-wrap-repeated");
        const seP = document.createElement("p");
        seP.textContent = "Sold Out!";
        seDiv.appendChild(seP);

        seProductLabel.parentElement.insertBefore(seDiv, seProductLabel.nextElementSibling);
      }
    }
    

    let regular_price = variant.price;
    let compare_price = variant.compare_at_price;
    let regular_price_output =
      '<span class="money regular_price" id="regular_price">' +
      theme.Currency.formatMoney(regular_price, theme.moneyFormat) +
      "</span>";

    if (compare_price > regular_price) {
      let compare_price_output =
        '<span class="money compare_price" id="compare_price"> <del>' +
        theme.Currency.formatMoney(compare_price, theme.moneyFormat) +
        "</del></span>";
      let saved_price = Math.round(compare_price - regular_price);
      let saved_price_output =
        '<span class="save_amount" id="save_amount"> Save ' +
        theme.Currency.formatMoney(saved_price, theme.moneyFormat) +
        "</span>";
      let output =
        regular_price_output + compare_price_output + saved_price_output;
      document.getElementById("product_price").innerHTML =
        output + seVariantMetafieldValue;

      let regularPriceElement = document.getElementById("regular_price");
      if (!regularPriceElement.hasAttribute("productprice")) {
        regularPriceElement.setAttribute(
          "productprice",
          (regular_price / 100).toFixed(2)
        );
      }
      document
        .querySelectorAll('input[name="quantity"]')
        .forEach(function (input) {
          quantityInputChange(input);
        });
    } else {
      let compare_price_output = "";
      let saved_price_output = "";
      let output =
        regular_price_output + compare_price_output + saved_price_output;
      document.getElementById("product_price").innerHTML =
        output + seVariantMetafieldValue;
      let regularPriceElement = document.getElementById("regular_price");
      if (!regularPriceElement.hasAttribute("productprice")) {
        regularPriceElement.setAttribute(
          "productprice",
          (regular_price / 100).toFixed(2)
        );
      }
      document
        .querySelectorAll('input[name="quantity"]')
        .forEach(function (input) {
          quantityInputChange(input);
        });
    }
  }
  function update_product_inventory(variant) {
    let variant_inventory = variant.inventory;
    document.getElementById("product_inventory").innerHTML = variant_inventory;
  }
  function update_current_sku(variant) {
    let variant_sku = variant.sku;
    if (variant_sku && document.querySelector(".variantSku")) {
      document.querySelector(".variantSku").innerHTML = "Item # " + variant_sku;
    }
  }
  function update_max_quantity(variant) {
    let variant_inventory = variant.inventory;
    if (variant_inventory && document.querySelector(".quantity_selector")) {
      document
        .querySelector(".quantity_selector")
        .setAttribute("max", variant_inventory);
    }
  }

  function update_add_to_cart_text(variant) {
    document.querySelectorAll(".AddToCartBtn").forEach((item) => {
      if (!variant.available) {
        item.classList.add("disabled");
        item.textContent = "Sold Out";
      } else {
        item.classList.remove("disabled");
        item.textContent = "Add to Cart";
      }
    });
  }

  function updateMasterVariant(variant) {
    let masterSelect = document.querySelector(".product-form__variants");
    masterSelect.value = variant.id;
  }

  document
    .querySelectorAll(
      ".product-option input[type=radio], .product-option select"
    )
    .forEach(function (radio) {
      radio.addEventListener("change", function () {
        let selectedValues = getVariantFromSwatches();
        let variants = window.product.variants;
        let found = false;

        variants.forEach(function (variant) {
          let satisfied = true;
          selectedValues.forEach(function (option) {
            if (satisfied) {
              satisfied = option.value === variant[option.index];
            }
          });
          if (satisfied) {
            found = variant;
          }
        });

        let isPotm = document.querySelector('[is-potm="true"]');

        if (found) {
          update_max_quantity(found);
          update_current_sku(found);
          update_add_to_cart_text(found);
          update_slider_image(found.featured_image);
          if (!isPotm) {
            update_variant_id(found.id);
            updateMasterVariant(found);
          } else {
            updatePotmPrice(found);
          }
          updateHistoryState(found);
          update_product_price(found);
          update_product_inventory(found);

          /* SE - 18 FEB '25 */
          const seVariantId = found.id;
          const currentVariant = window.product.variants.find(variant => variant.id == seVariantId);
          if (currentVariant) {
            const currentFeaturedImageSrc = currentVariant.featured_image_src;
            document.querySelectorAll(".gallery-top img[data-se-image-id]")?.forEach(img => {
              const imgDataId = img.getAttribute("data-se-image-id");
              if (imgDataId && currentFeaturedImageSrc && currentFeaturedImageSrc.includes(imgDataId)) {
                const seSlide = img.closest(".swiper-slide");
                const seDataIndex = seSlide.getAttribute("data-index");
                update_slider_image(false, seDataIndex);
              }
            });
          }

        }
      });
    });

  // Choose Options click
  const scrollOptions = document.getElementById("scrollOptions");
  if (scrollOptions) {
    scrollOptions.addEventListener("click", function () {
      document.querySelector(".main__product").scrollIntoView({
        behavior: "smooth",
      });
    });
  }

  // Expand More text Button
  document.querySelectorAll(".expandButton").forEach((button) => {
    button.addEventListener("click", function () {
      const richTextInner = this.closest(".rich-text__inner");
      if (richTextInner) {
        const subheadings = richTextInner.querySelectorAll(
          ".rich-text__subheading"
        );
        if (subheadings.length > 0) {
          const isVisible = subheadings[0].classList.contains("visible");
          subheadings.forEach((subheading) => {
            subheading.classList.toggle("visible", !isVisible);
          });
          if (isVisible) {
            this.textContent = "Read More";
          } else {
            this.textContent = "Read Less";
          }
        }
      }
    });
  });

  //     // CUSTOM PRINTED WORK

  let customPrintedSizeOptions = document.querySelectorAll(
    '.custom_print__option > input[name="customPrint"]'
  );
  let shirtSizeNo = document.getElementById("shirtSize__no");
  let shirtSizeYes = document.getElementById("shirtSize__yes");
  customPrintedSizeOptions.forEach((input) => {
    input.addEventListener("click", () => {
      shirtSizeYes.classList.remove("hidden");
      shirtSizeNo.classList.remove("flex");
      if (input.value == "yes") {
        shirtSizeYes.classList.remove("hidden");
        shirtSizeNo.classList.add("hidden");
      } else {
        shirtSizeYes.classList.add("hidden");
        shirtSizeNo.classList.remove("hidden");
      }
    });
  });

  let secondImageInput = document.querySelector(
    'label[data-validation-field="file-input-2"]'
  );
  let secondImageInputOptions = document.querySelectorAll(
    "#back_side__options .back_side__option"
  );
  secondImageInputOptions.forEach((option) => {
    option.addEventListener("click", () => {
      let optionLabel = document.querySelector(
        "#back_side__options .label-file-input-2"
      );
      let dataValue = option.getAttribute("data-value");
      if (dataValue == "yes") {
        secondImageInput.classList.remove("hidden");
        optionLabel.classList.remove("hidden");
        secondImageInput.classList.add("flex");
      } else {
        secondImageInput.classList.add("hidden");
        optionLabel.classList.add("hidden");
        secondImageInput.classList.remove("flex");
      }
    });
  });

  let customDesignNotesInput = document.getElementById(
    "custom_artwork_design__notes"
  );
  let customDesignOptions = document.querySelectorAll(
    '#custom-artwork-design__options [data-validation-field="custom-artwork-design__option"]'
  );
  customDesignOptions.forEach((option) => {
    option.addEventListener("click", () => {
      let dataValue = option.getAttribute("data-value");
      if (dataValue == "yes") {
        customDesignNotesInput.classList.remove("hidden");
      } else {
        customDesignNotesInput.classList.add("hidden");
      }
    });
  });

  const customPrintedContainer = document.querySelector(
    ".product_has_variants"
  );
  if (!customPrintedContainer) return; // Exit if not a custom-printed product

  const customPrintedQuantityInput =
    customPrintedContainer.querySelector("input[type=number]");
  const customPrintedVariantSelect = document.querySelector(
    ".form-control.form_action.variant-option"
  );

  if (!customPrintedQuantityInput || !customPrintedVariantSelect) return;

  function updateCustomPrintedVariant() {
    if (document.querySelector(".option_label").classList.contains("hidden")) {
      const quantity = parseInt(customPrintedQuantityInput.value);
      let selectedVariant = null;

      const customPrintedVariantOptions = Array.from(
        customPrintedVariantSelect.options
      )
        .filter((option) => option.value !== "Choose an option") // Exclude the "Choose an option" choice
        .map((option) => ({
          value: option.value,
          threshold: parseInt(option.value) || 1, // Default to 1 if parsing fails
        }))
        .sort((a, b) => b.threshold - a.threshold);
      console.log(customPrintedVariantOptions, "customPrintedVariantOptions");
      // Find the appropriate variant based on quantity
      for (let variant of customPrintedVariantOptions) {
        if (quantity >= variant.threshold) {
          selectedVariant = variant.value;
          break;
        }
      }

      // If no variant is selected, choose the first one
      if (!selectedVariant && customPrintedVariantOptions.length > 0) {
        selectedVariant =
          customPrintedVariantOptions[customPrintedVariantOptions.length - 1]
            .value;
      }

      // Select the variant if found
      if (selectedVariant) {
        customPrintedVariantSelect.value = selectedVariant;
        customPrintedVariantSelect.dispatchEvent(
          new Event("change", { bubbles: true })
        );
      }
    }
  }

  customPrintedQuantityInput.addEventListener(
    "change",
    updateCustomPrintedVariant
  );

  const customPrintedPlusButton = customPrintedContainer.querySelector(".plus");
  const customPrintedMinusButton =
    customPrintedContainer.querySelector(".minus");

  customPrintedPlusButton.addEventListener("click", updateCustomPrintedVariant);
  customPrintedMinusButton.addEventListener(
    "click",
    updateCustomPrintedVariant
  );

  // Initial update
  updateCustomPrintedVariant();

  // Ensure the quantity doesn't go below the minimum
  const minCustomPrintedQuantity =
    parseInt(customPrintedQuantityInput.getAttribute("min")) || 1;

  customPrintedQuantityInput.addEventListener("change", function () {
    if (parseInt(this.value) < minCustomPrintedQuantity) {
      this.value = minCustomPrintedQuantity;
      updateCustomPrintedVariant();
    }
  });

  customPrintedMinusButton.addEventListener("click", function () {
    if (
      parseInt(customPrintedQuantityInput.value) <= minCustomPrintedQuantity
    ) {
      customPrintedQuantityInput.value = minCustomPrintedQuantity;
      updateCustomPrintedVariant();
    }
  });
});

function globalStepDown(step, element) {
  element.stepDown(step);
  let productPrice = parseFloat(
    document.getElementById("regular_price").getAttribute("productPrice")
  );

  let breakdown = element.getAttribute("data-quantityDiscountQuantityBreakdown")
    ? element.getAttribute("data-quantityDiscountQuantityBreakdown").split(",")
    : [];
  let priceBreakdown = element.getAttribute("data-quantityDiscountPercentage")
    ? element.getAttribute("data-quantityDiscountPercentage").split(",")
    : [];
  if (breakdown.length > 0 && priceBreakdown.length > 0) {
    let mergedBreakdown = breakdown.map((key, index) => {
      return { [key]: priceBreakdown[index] };
    });

    let currentQuantity = parseInt(element.value);
    let updated = false;
    for (let discount of mergedBreakdown) {
      let quantity = parseInt(Object.keys(discount)[0]);
      let discountPercentage = parseFloat(Object.values(discount)[0]);
      if (currentQuantity >= quantity) {
        let discountedPrice = productPrice * (1 - discountPercentage / 100);
        document.getElementById("regular_price").innerText =
          "$" + discountedPrice.toFixed(2) + " per piece";
        updated = true;
      }
    }
    if (!updated) {
      document.getElementById("regular_price").innerText =
        "$" + productPrice.toFixed(2) + " per piece";
    }
  }
}

function globalStepUp(step, element) {
  element.stepUp(step);
  let productPrice = parseFloat(
    document.getElementById("regular_price").getAttribute("productPrice")
  );

  let breakdown = element.getAttribute("data-quantityDiscountQuantityBreakdown")
    ? element.getAttribute("data-quantityDiscountQuantityBreakdown").split(",")
    : [];
  let priceBreakdown = element.getAttribute("data-quantityDiscountPercentage")
    ? element.getAttribute("data-quantityDiscountPercentage").split(",")
    : [];
  if (breakdown.length > 0 && priceBreakdown.length > 0) {
    let mergedBreakdown = breakdown.map((key, index) => {
      return { [key]: priceBreakdown[index] };
    });
    console.log(mergedBreakdown, "breakdown");
    console.log(priceBreakdown, "priceBreakdown");

    let currentQuantity = parseInt(element.value);
    let updated = false;
    for (let discount of mergedBreakdown) {
      let quantity = parseInt(Object.keys(discount)[0]);
      let discountPercentage = parseFloat(Object.values(discount)[0]);
      if (currentQuantity >= quantity) {
        let discountedPrice = productPrice * (1 - discountPercentage / 100);
        document.getElementById("regular_price").innerText =
          "$" + discountedPrice.toFixed(2) + " per piece";
        updated = true;
      }
    }
    if (!updated) {
      document.getElementById("regular_price").innerText =
        "$" + productPrice.toFixed(2) + " per piece";
    }
  }
}

function quantityInputChange(element) {
  let productPrice = parseFloat(
    document.getElementById("regular_price").getAttribute("productPrice")
  );

  let breakdown = element.getAttribute("data-quantityDiscountQuantityBreakdown")
    ? element.getAttribute("data-quantityDiscountQuantityBreakdown").split(",")
    : [];
  let priceBreakdown = element.getAttribute("data-quantityDiscountPercentage")
    ? element.getAttribute("data-quantityDiscountPercentage").split(",")
    : [];
  if (breakdown.length > 0 && priceBreakdown.length > 0) {
    let mergedBreakdown = breakdown.map((key, index) => {
      return { [key]: priceBreakdown[index] };
    });
    console.log(mergedBreakdown, "breakdown");
    console.log(priceBreakdown, "priceBreakdown");

    let currentQuantity = parseInt(element.value);
    let updated = false;
    for (let discount of mergedBreakdown) {
      let quantity = parseInt(Object.keys(discount)[0]);
      let discountPercentage = parseFloat(Object.values(discount)[0]);
      if (currentQuantity >= quantity) {
        let discountedPrice = productPrice * (1 - discountPercentage / 100);
        document.getElementById("regular_price").innerText =
          "$" + discountedPrice.toFixed(2) + " per piece";
        updated = true;
      }
    }
    if (!updated) {
      document.getElementById("regular_price").innerText =
        "$" + productPrice.toFixed(2) + " per piece";
    }
  }
}

document.addEventListener("cart-drawer:open", function (evt) {
  console.log("Cart drawer opened");
});

/* Keep desktop Searchanise filters in place while their results refresh. */
(function () {
  var pending = null;
  var frame = 0;
  var connected = false;
  var sidebarSelector = '.snize-filters-sidebar';
  function cancel() {
    pending = null;
    cancelAnimationFrame(frame);
  }
  function restore() {
    if (!pending) return;
    if (Date.now() > pending.until) { cancel(); return; }
    var group = document.getElementById(pending.id);
    if (group && group.getBoundingClientRect().height) {
      var list = group.querySelector('.snize-product-filters-list');
      if (list && Math.abs(list.scrollTop - pending.listScroll) > 1) {
        list.scrollTop = pending.listScroll;
      }
      var delta = group.getBoundingClientRect().top - pending.top;
      if (Math.abs(delta) > 1) {
        window.scrollTo({ top: window.scrollY + delta, behavior: 'instant' });
      }
    }
    frame = requestAnimationFrame(restore);
  }
  function remember(event) {
    if (!window.matchMedia('(min-width: 992px)').matches) return;
    var target = event.target;
    if (!(target instanceof Element)) return;
    var sidebar = target.closest(sidebarSelector);
    if (!sidebar) return;
    var label = target.closest('label');
    var control = target.closest('.snize-price-range, .snize-product-filters-checkbox, .snize-product-filters-clear, .snize-product-filters-reset-all');
    if (!control && !(label && label.querySelector('.snize-product-filters-checkbox'))) return;
    var group = target.closest('.snize-product-filters-block') || sidebar.querySelector('.snize-product-filters-block');
    if (!group || !group.id) return;
    var list = group.querySelector('.snize-product-filters-list');
    cancelAnimationFrame(frame);
    pending = { id: group.id, top: group.getBoundingClientRect().top,
      listScroll: list ? list.scrollTop : 0, until: Date.now() + 8000 };
    frame = requestAnimationFrame(restore);
  }
  // Capture before the widget handles a mouse, keyboard, or price interaction.
  document.addEventListener('click', remember, true);
  document.addEventListener('change', function (event) {
    if (event.target.matches('.snize-price-range-input')) remember(event);
  }, true);
  document.addEventListener('pointerdown', function (event) {
    if (!event.target.closest(sidebarSelector)) cancel();
  }, true);
  document.addEventListener('input', function (event) {
    if (event.target.matches('.snize-price-range-input')) remember(event);
  }, true);
  // Never fight the customer's deliberate scrolling or navigation.
  window.addEventListener('wheel', cancel, { passive: true });
  window.addEventListener('touchmove', cancel, { passive: true });
  document.addEventListener('keydown', function (event) {
    if (['PageUp', 'PageDown', 'Home', 'End', 'Escape'].includes(event.key)) cancel();
  }, true);
  window.addEventListener('popstate', cancel);
  function connect() {
    if (connected || !window.Searchanise || !window.Searchanise.$) return;
    connected = true;
    window.Searchanise.$(document).on('Searchanise.ResultsUpdated', function () {
      if (!pending) return;
      window.Searchanise.$('html, body').stop(true);
      pending.until = Date.now() + 600;
      cancelAnimationFrame(frame);
      restore();
    });
  }
  document.addEventListener('Searchanise.Loaded', connect);
  connect();
})();
